'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _adUtility = require('../../../utils/ad-utility');

var _hudlVideoInterface = require('hudl-video-interface');

var _ItemPreview = require('../ItemPreview');

var _ItemPreview2 = _interopRequireDefault(_ItemPreview);

var _PlaybackEventNotifier = require('../PlaybackEventNotifier');

var _PlaybackEventNotifier2 = _interopRequireDefault(_PlaybackEventNotifier);

var _VideoOverlay = require('../utils/VideoOverlay');

var _VideoOverlay2 = _interopRequireDefault(_VideoOverlay);

var _propTypes = require('../../../shared/prop-types');

require('./_community-video-player.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CommunityVideoPlayer = function (_Component) {
  _inherits(CommunityVideoPlayer, _Component);

  function CommunityVideoPlayer(props) {
    _classCallCheck(this, CommunityVideoPlayer);

    var _this = _possibleConstructorReturn(this, (CommunityVideoPlayer.__proto__ || Object.getPrototypeOf(CommunityVideoPlayer)).call(this, props));

    _this.onVideoOverlayClick = function (e) {
      e.preventDefault();
      e.stopPropagation();
      var player = _this.props.player;

      if (!player.fullscreen && !player.adBegan) {
        _this.props.onVideoOverlayClick();
      }
    };

    _this.onShowPreview = function (isPrevious) {
      if (isPrevious) {
        _this.setState({
          hideNextPreview: true,
          hidePreviousPreview: false
        });
      } else {
        _this.setState({
          hideNextPreview: false,
          hidePreviousPreview: true
        });
      }
    };

    _this.state = {
      snapShotPlayables: props.playables || []
    };

    // Only support initial snapshot startime, otherwise
    // it can mess with playlist start times.
    _this.snapShotStartTimeMs = props.startTimeMs;
    return _this;
  }

  _createClass(CommunityVideoPlayer, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      (0, _hudlVideoInterface.setStoreInstance)(this.context.store);
      this.mounted = true;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.fetchHeaderBid();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          player = _props.player,
          play = _props.play,
          playerId = _props.playerId,
          setCurrentTimeMs = _props.setCurrentTimeMs;

      // Player is starting up, seek if needed, play if needed.

      if (!player.canPlay && nextProps.player.canPlay) {
        if (this.snapShotStartTimeMs && this.snapShotStartTimeMs > 0) {
          var startTimeMs = this.snapShotStartTimeMs;
          this.snapShotStartTimeMs = 0;
          setCurrentTimeMs(playerId, startTimeMs);
          // JW player requires a play after a setCurrrentTimeMS call.
          play(playerId);
        }
      }

      // Set preview information for the previous and next video
      var playablesChanged = player.playables !== nextProps.player.playables;
      var previewsChanged = nextProps.itemPreviews !== this.props.itemPreviews;
      var playingIndexChanged = player.playingIndex !== nextProps.player.playingIndex;
      if (previewsChanged || playingIndexChanged || playablesChanged) {
        var previousItem = void 0;
        var nextItem = void 0;

        var playingIndex = nextProps.player.playingIndex;
        if (nextProps.itemPreviews && nextProps.itemPreviews.length >= playingIndex) {
          if (playingIndex > 0) {
            previousItem = nextProps.itemPreviews[playingIndex - 1];
          }
          if (playingIndex < nextProps.player.playables.size) {
            nextItem = nextProps.itemPreviews[playingIndex + 1];
          }
        }

        this.setState({
          previousItem: previousItem,
          nextItem: nextItem
        });
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return nextProps.player !== this.props.player || nextProps.muted !== this.props.muted || nextState.hideNextPreview !== this.state.hideNextPreview || nextState.hidePreviousPreview !== this.state.hidePreviousPreview || nextState.previousItem !== this.state.previousItem || nextState.nextItem !== this.state.nextItem;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mounted = false;
      this.isHackEnabledFix = false;
    }
  }, {
    key: 'renderPlayer',
    value: function renderPlayer() {
      var _props2 = this.props,
          adTag = _props2.adTag,
          durationMs = _props2.durationMs,
          children = _props2.children,
          muted = _props2.muted,
          autoplay = _props2.autoplay,
          onVideoOverlayClick = _props2.onVideoOverlayClick,
          player = _props2.player,
          playerId = _props2.playerId,
          playerTech = _props2.playerTech,
          setAutoAdvance = _props2.setAutoAdvance,
          setPlayingIndex = _props2.setPlayingIndex,
          trackInViewVideo = _props2.trackInViewVideo;
      var snapShotPlayables = this.state.snapShotPlayables;


      var logData = _extends({}, this.props.logData, {
        isAutoPlay: autoplay
      });

      var adIsPlaying = player.adBegan && !player.adEnded;

      var ads = (0, _adUtility.getAds)(adTag, durationMs, this.props.headerBid);
      // Force JW if we need ad support
      var selectedPlayerTech = ads !== null ? 'jw' : playerTech;
      var preloadType = autoplay ? 'auto' : 'none';

      if (!this.props.triedFetchHeaderBid) {
        return null;
      }

      return _react2.default.createElement(
        _hudlVideoInterface.VideoProvider,
        { className: 'community-video-player', playerId: playerId, muted: muted },
        _react2.default.createElement(
          _hudlVideoInterface.Video,
          {
            preload: preloadType,
            autoplay: autoplay,
            playables: snapShotPlayables,
            player: selectedPlayerTech,
            ads: ads,
            useFadeWrapperOnVideo: !adIsPlaying },
          !adIsPlaying && onVideoOverlayClick && _react2.default.createElement(_VideoOverlay2.default, {
            className: 'community-video-player__overlay',
            placement: 'OVER_VIDEO',
            onClick: this.onVideoOverlayClick
          }),
          !adIsPlaying && _react2.default.createElement(
            _hudlVideoInterface.Row,
            { placement: 'ON_VIDEO', fadeOut: true },
            _react2.default.createElement(
              _hudlVideoInterface.TimeSubscriber,
              null,
              _react2.default.createElement(_hudlVideoInterface.ProgressBar, null)
            )
          ),
          !adIsPlaying && _react2.default.createElement(
            _hudlVideoInterface.Row,
            { placement: 'ON_VIDEO', fadeOut: true, rightControls: [_hudlVideoInterface.Volume, _hudlVideoInterface.Fullscreen] },
            snapShotPlayables.length > 1 && _react2.default.createElement(
              _ItemPreview2.default,
              {
                hide: this.state.hidePreviousPreview,
                onShow: this.onShowPreview,
                previous: this.state.previousItem,
                player: player,
                setPlayingIndex: setPlayingIndex },
              _react2.default.createElement(_hudlVideoInterface.PreviousItem, { title: '' })
            ),
            _react2.default.createElement(_hudlVideoInterface.PlayPause, null),
            snapShotPlayables.length > 1 && _react2.default.createElement(
              _hudlVideoInterface.TimeSubscriber,
              null,
              _react2.default.createElement(
                _ItemPreview2.default,
                {
                  hide: this.state.hideNextPreview,
                  next: this.state.nextItem,
                  onShow: this.onShowPreview,
                  player: player,
                  setAutoAdvance: setAutoAdvance,
                  setPlayingIndex: setPlayingIndex },
                _react2.default.createElement(_hudlVideoInterface.NextItem, { title: '' })
              )
            ),
            _react2.default.createElement(
              _hudlVideoInterface.TimeSubscriber,
              null,
              _react2.default.createElement(_hudlVideoInterface.Time, null)
            ),
            _react2.default.createElement(_hudlVideoInterface.Volume, null),
            _react2.default.createElement(_hudlVideoInterface.Fullscreen, null)
          )
        ),
        _react2.default.createElement(
          _hudlVideoInterface.TimeSubscriber,
          null,
          _react2.default.createElement(_PlaybackEventNotifier2.default, { logData: logData, playerId: playerId, trackInViewVideo: trackInViewVideo })
        ),
        !adIsPlaying && children
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var player = this.renderPlayer();
      return _react2.default.createElement(
        'div',
        { className: 'community-video-player-container' },
        _react2.default.createElement(
          'div',
          { className: 'community-video-player__waypoint-hook' },
          player
        )
      );
    }
  }]);

  return CommunityVideoPlayer;
}(_react.Component);

CommunityVideoPlayer.propTypes = {
  adTag: _propTypes.adTagShape,
  autoplay: _react.PropTypes.bool,
  children: _react.PropTypes.arrayOf(_react.PropTypes.element),
  durationMs: _react.PropTypes.number,
  fetchHeaderBid: _react.PropTypes.func.isRequired,
  headerBid: _react.PropTypes.string,
  itemPreviews: _react.PropTypes.arrayOf(_propTypes.PlayablePreview),
  logData: _react.PropTypes.shape({
    container: _react.PropTypes.number.isRequired,
    isAutoAdvance: _react.PropTypes.bool,
    player: _react.PropTypes.number.isRequired
  }).isRequired,
  muted: _react.PropTypes.bool,
  onVideoOverlayClick: _react.PropTypes.func,
  play: _react.PropTypes.func.isRequired,
  playables: _react.PropTypes.arrayOf(_propTypes.CommunityContentPlayable).isRequired,
  player: _react.PropTypes.object,
  playerId: _react.PropTypes.string.isRequired,
  playerTech: _react.PropTypes.string,
  setAutoAdvance: _react.PropTypes.func.isRequired,
  setCurrentTimeMs: _react.PropTypes.func.isRequired,
  setPlayingIndex: _react.PropTypes.func.isRequired,
  startTimeMs: _react.PropTypes.number,
  trackInViewVideo: _react.PropTypes.bool,
  triedFetchHeaderBid: _react.PropTypes.bool
};
CommunityVideoPlayer.contextTypes = {
  store: _react.PropTypes.object
};
CommunityVideoPlayer.defaultProps = {
  autoplay: true,
  trackInViewVideo: false,
  durationMs: 0,
  logData: {},
  playerTech: 'theo',
  startTimeMs: 0
};
exports.default = CommunityVideoPlayer;